/** Bluewell identity and single-portal owner sign-in configuration. */
export const APP_CONFIG = {
  name: 'Bluewell Ventures',
  tagline: 'Tea and coffee store administration',
  emoji: '🍵',
  icon: 'Coffee',
  defaultTheme: 'system',
  defaultLoginRoute: '/login',
};

export const AUTH_PROFILES = null;

export const GENERIC_AUTH = {
  loginTitle: 'Owner sign in',
  signupTitle: 'Account creation is closed',
  loginDescription: 'Use the owner account provisioned privately in Apper.',
  signupDescription: 'Public account creation is disabled for this owner-only workspace.',
  redirectAfterAuth: '/admin',
};